/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReportDocumentPayload
 */
export interface CreateReportDocumentPayload {
    /**
     * The patient ID to add the report to
     * @type {string}
     * @memberof CreateReportDocumentPayload
     */
    patient_id: string;
    /**
     * The title of the report
     * @type {string}
     * @memberof CreateReportDocumentPayload
     */
    title: string;
    /**
     * The markdown or HTML content of the report
     * @type {string}
     * @memberof CreateReportDocumentPayload
     */
    content: string;
    /**
     * The format of the content field
     * @type {string}
     * @memberof CreateReportDocumentPayload
     */
    content_type?: CreateReportDocumentPayloadContentTypeEnum;
    /**
     * Optional appointment ID to link the report to
     * @type {string}
     * @memberof CreateReportDocumentPayload
     */
    appointment_id?: string;
}


/**
 * @export
 */
export const CreateReportDocumentPayloadContentTypeEnum = {
    Markdown: 'markdown',
    Html: 'html'
} as const;
export type CreateReportDocumentPayloadContentTypeEnum = typeof CreateReportDocumentPayloadContentTypeEnum[keyof typeof CreateReportDocumentPayloadContentTypeEnum];


/**
 * Check if a given object implements the CreateReportDocumentPayload interface.
 */
export function instanceOfCreateReportDocumentPayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "patient_id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "content" in value;

    return isInstance;
}

export function CreateReportDocumentPayloadFromJSON(json: any): CreateReportDocumentPayload {
    return CreateReportDocumentPayloadFromJSONTyped(json, false);
}

export function CreateReportDocumentPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReportDocumentPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': json['patient_id'],
        'title': json['title'],
        'content': json['content'],
        'content_type': !exists(json, 'content_type') ? undefined : json['content_type'],
        'appointment_id': !exists(json, 'appointment_id') ? undefined : json['appointment_id'],
    };
}

export function CreateReportDocumentPayloadToJSON(value?: CreateReportDocumentPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
        'title': value.title,
        'content': value.content,
        'content_type': value.content_type,
        'appointment_id': value.appointment_id,
    };
}

